import { html } from "lit";
import { getDummyText } from "../../../utils";

export const smartFactoryData = {
    static: true,
    isSourceCode: true,
};

export const iconNames = [
    "application-laser-cutting",
    "avatar-technical-service",
    "financial-sales",
    "globe-fine",
    "calendar",
];

export const SmartFactoryTemplate = (args) => {
    let tiles = [];

    for (let i = 0; i < args.tilesPerRow; i++) {
        tiles.push(html`
            <ux-iws-interactive-tile
                interactive="${!args.static ? `true` : `false`}"
            >
                <div slot="headline" data-same-height="headline">
                    ${getDummyText(20)}
                </div>
                <div slot="copy-text">
                    <p>${getDummyText(100)}</p>
                </div>
                <div slot="link">
                    <a href="#" class="ux-text-link ux-text-link--green">
                        <span>Mehr erfahren</span>
                        <ux-icon name="arrow-small-right"></ux-icon>
                    </a>
                </div>
            </ux-iws-interactive-tile>
        `);
    }

    return html`
        <div class="row">
            <div class="gr-10 push-1 gr-12@m push-0@m">
                <ux-same-height>
                    <ux-iws-interactive-tiles
                        content-centered="${args.contentCentered}"
                        background-image-s="./mock-assets/images/csm-applications.jpg"
                        background-image-m="./mock-assets/images/csm-applications.jpg"
                        background-image-l="./mock-assets/images/csm-applications.jpg"
                    >
                        ${tiles}
                    </ux-iws-interactive-tiles>
                </ux-same-height>
            </div>
        </div>
    `;
};

export const SmartFactoryIconTemplate = (args) => {
    let tiles = [];

    for (let i = 0; i < args.tilesPerRow; i++) {
        tiles.push(html`
            <ux-iws-interactive-tile
                interactive="${!args.static ? `true` : `false`}"
                icon-name="${iconNames[i]}"
            >
                <div slot="headline" data-same-height="headline">
                    ${getDummyText(20)}
                </div>
                <div slot="copy-text">
                    <p>${getDummyText(100)}</p>
                </div>
                <div slot="link">
                    <a href="#" class="ux-text-link ux-text-link--green">
                        <span>Mehr erfahren</span>
                        <ux-icon name="arrow-small-right"></ux-icon>
                    </a>
                </div>
            </ux-iws-interactive-tile>
        `);
    }

    return html`
        <div class="row">
            <div class="gr-10 push-1 gr-12@m push-0@m">
                <ux-same-height>
                    <ux-iws-interactive-tiles
                        content-centered="${args.contentCentered}"
                        background-image-s="./mock-assets/images/csm-applications.jpg"
                        background-image-m="./mock-assets/images/csm-applications.jpg"
                        background-image-l="./mock-assets/images/csm-applications.jpg"
                    >
                        ${tiles}
                    </ux-iws-interactive-tiles>
                </ux-same-height>
            </div>
        </div>
    `;
};

export const SmartFactoryNumbersTemplate = (args) => {
    let tiles = [];

    for (let i = 0; i < args.tilesPerRow; i++) {
        tiles.push(html`
            <ux-iws-interactive-tile
                interactive="${!args.static ? `true` : `false`}"
                number="${i}"
            >
                <div slot="headline" data-same-height="headline">
                    ${getDummyText(20)}
                </div>
                <div slot="copy-text">
                    <p>${getDummyText(100)}</p>
                </div>
                <div slot="link">
                    <a href="#" class="ux-text-link ux-text-link--green">
                        <span>Mehr erfahren</span>
                        <ux-icon name="arrow-small-right"></ux-icon>
                    </a>
                </div>
            </ux-iws-interactive-tile>
        `);
    }

    return html`
        <div class="row">
            <div class="gr-10 push-1 gr-12@m push-0@m">
                <ux-same-height>
                    <ux-iws-interactive-tiles
                        content-centered="${args.contentCentered}"
                        background-image-s="./mock-assets/images/csm-applications.jpg"
                        background-image-m="./mock-assets/images/csm-applications.jpg"
                        background-image-l="./mock-assets/images/csm-applications.jpg"
                    >
                        ${tiles}
                    </ux-iws-interactive-tiles>
                </ux-same-height>
            </div>
        </div>
    `;
};
